module.exports = __webpack_public_path__ + "img/slika4.8e674de7.jpg";